/** Shared time helpers and the per-race planner settings saved by the Fuelling tab. */

export interface PlannerSettings {
  weightKg: number;
  loadStyle: 'three' | 'two';
  waveId: string;
  finish: string;
  ratePerHour: number;
}

export const plannerStorageKey = (raceId: string) => `fuel-settings:${raceId}`;

export const readPlannerSettings = (raceId: string): Partial<PlannerSettings> => {
  try {
    const raw = localStorage.getItem(plannerStorageKey(raceId));
    return raw ? (JSON.parse(raw) as Partial<PlannerSettings>) : {};
  } catch {
    return {};
  }
};

/** Adds minutes to a local HH:MM, wrapping at midnight. */
export const addMinutes = (hhmm: string, minutes: number): string => {
  const [h, m] = hhmm.split(':').map(Number);
  const total = (((h * 60 + m + Math.round(minutes)) % 1440) + 1440) % 1440;
  return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
};

/** Parses a marathon goal like "3:30" into minutes; null if it isn't a plausible finish time. */
export const parseFinish = (finish: string): number | null => {
  const match = /^(\d{1,2}):(\d{2})$/.exec(finish.trim());
  if (!match) return null;
  const minutes = Number(match[1]) * 60 + Number(match[2]);
  return minutes >= 90 && minutes <= 480 ? minutes : null;
};
